import styled from 'styled-components';

export const ConstructionCustomTableCell = styled.span`
  word-break: break-word;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.gray8};
  padding-top: 0.5rem;
`;

export const TableMenuContainer = styled.div`
  margin: 0.5rem 1.5rem 1rem 1.5rem;
`;

export const ContractTableContainer = styled.div`
  margin: 0rem 1.5rem 1rem 1.5rem;
`;
